<div class="h-full footer-body flex justify-end items-end pt-2">
    <div class="flex justify-end items-end">
        <ng-content></ng-content>
    </div>
</div>
